import gql from "graphql-tag";

export const AGREE_TO_IBKR_FORM = gql`
  mutation AgreeToIBKRForm($orderId: ID!, $formNumber: String!) {
    agreeToIBKRForm(orderId: $orderId, formNumber: $formNumber) {
      feedback
    }
  }
`;
